import ShopCardGrid from "./ShopCardGrid";

export default function ShopsMainBox({cards, handleUpdate, handleDelete, selectedIds, onToggleSelect, handleManageBilling, handleCancelSubscription, handleStartBilling, handleStartSetup}) {
  return (
    <div className="w-full">
      <ShopCardGrid
        cards={cards}
        handleUpdate={handleUpdate}
        handleDelete={handleDelete}
        selectedIds={selectedIds}
        onToggleSelect={onToggleSelect}
        handleManageBilling={handleManageBilling}
        handleCancelSubscription={handleCancelSubscription}
        handleStartBilling={handleStartBilling}
        handleStartSetup={handleStartSetup}
      />
    </div>
  );
}
